module.exports = __webpack_public_path__ + "img/marathon_icon.f273254b.png";